/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M11 13H7L11 9V13ZM11 13V15M13.5 9V13M13.5 13V15M13.5 13L14.375 12M14.375 12L17 9M14.375 12L17 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M11 13H7L11 9V13ZM11 13V15M13.5 9V13M13.5 13V15M13.5 13L14.375 12M14.375 12L17 9M14.375 12L17 15M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM11.75 8.99999C11.75 8.69664 11.5673 8.42316 11.287 8.30708C11.0068 8.19099 10.6842 8.25516 10.4697 8.46966L6.46967 12.4697C6.25517 12.6842 6.191 13.0067 6.30709 13.287C6.42318 13.5673 6.69665 13.75 7 13.75H10.25V15C10.25 15.4142 10.5858 15.75 11 15.75C11.4142 15.75 11.75 15.4142 11.75 15V13V8.99999ZM10.25 10.8106V12.25H8.81066L10.25 10.8106ZM17.5644 9.49387C17.8372 9.18214 17.8056 8.70832 17.4939 8.43555C17.1822 8.16279 16.7083 8.19438 16.4356 8.50611L14.25 11.0039V8.99999C14.25 8.58577 13.9142 8.24999 13.5 8.24999C13.0858 8.24999 12.75 8.58577 12.75 8.99999V13V15C12.75 15.4142 13.0858 15.75 13.5 15.75C13.9142 15.75 14.25 15.4142 14.25 15V13.2818L14.375 13.1389L16.4356 15.4939C16.7083 15.8056 17.1822 15.8372 17.4939 15.5644C17.8056 15.2917 17.8372 14.8178 17.5644 14.5061L15.3716 12L17.5644 9.49387Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 10V9.5V9.5C22 7.17029 22 6.00544 21.6194 5.08658C21.1119 3.86144 20.1386 2.88807 18.9134 2.3806C17.9946 2 16.8297 2 14.5 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14.5C16.8297 22 17.9946 22 18.9134 21.6194C20.1386 21.1119 21.1119 20.1386 21.6194 18.9134C22 17.9946 22 16.8297 22 14.5V14.5V14M11 13H7L11 9V13ZM11 13V15M13.5 9V13M13.5 13V15M13.5 13L14.375 12M14.375 12L17 9M14.375 12L17 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M11 13H7L11 9V13ZM11 13V15M13.5 9V13M13.5 13V15M13.5 13L14.375 12M14.375 12L17 9M14.375 12L17 15M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.287 8.30711C11.5673 8.4232 11.75 8.69668 11.75 9.00002V13V15C11.75 15.4142 11.4142 15.75 11 15.75C10.5858 15.75 10.25 15.4142 10.25 15V13.75H7.00002C6.69668 13.75 6.4232 13.5673 6.30711 13.287C6.19103 13.0068 6.25519 12.6842 6.46969 12.4697L10.4697 8.46969C10.6842 8.25519 11.0068 8.19103 11.287 8.30711ZM10.25 12.25V10.8107L8.81068 12.25H10.25ZM17.4939 8.43559C17.8056 8.70835 17.8372 9.18217 17.5645 9.4939L15.3716 12L17.5645 14.5061C17.8372 14.8179 17.8056 15.2917 17.4939 15.5645C17.1822 15.8372 16.7084 15.8056 16.4356 15.4939L14.375 13.139L14.25 13.2818V15C14.25 15.4142 13.9142 15.75 13.5 15.75C13.0858 15.75 12.75 15.4142 12.75 15V13V9.00002C12.75 8.58581 13.0858 8.25002 13.5 8.25002C13.9142 8.25002 14.25 8.58581 14.25 9.00002V11.0039L16.4356 8.50614C16.7084 8.19442 17.1822 8.16283 17.4939 8.43559Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
